import { render } from "./Article.vue?vue&type=template&id=2333a7d2&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=2333a7d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2333a7d2"

export default script